<template>
  <div class="cn-drivers-list">
    <div class="cn-drivers-list__content">
      <template v-if="loading">
        <div v-for="i in 6" :key="i">
          <DriverCardSkeleton />
        </div>
      </template>
      <template v-else>
        <slot />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import DriverCardSkeleton from '@/components/DriverCardSkeleton';

interface Props {
  loading?: boolean;
}
defineProps<Props>();
</script>
<style lang="scss">
.cn-drivers-list {
  &__content {
    > :not([hidden]) ~ :not([hidden]) {
      margin-top: var(--size-lg);
    }
  }
}
</style>
